import { render } from "./VerifyEmailView.vue?vue&type=template&id=7898dbfc&scoped=true"
import script from "./VerifyEmailView.vue?vue&type=script&lang=js"
export * from "./VerifyEmailView.vue?vue&type=script&lang=js"

import "./VerifyEmailView.vue?vue&type=style&index=0&id=7898dbfc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Verent_PactoAdmin_FE_UI/Verent_PactoAdmin_FE_UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7898dbfc"]])

export default __exports__